// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ABOUT_ME_CHANGE_PROFILE = "Uprav profil";
export const ABOUT_ME_FOLLOWERS_count = "Obl\u00edbili si m\u011b (%(count)s)";
export const ABOUT_ME_FOLLOWING_count = "Moji obl\u00edben\u00ed (%(count)s)";
export const ABOUT_ME_GROUPS_count = "Skupin (%(count)s)";
export const ABOUT_ME_MORE_ABOUT_ME = "v\u00edce o m\u011b";
export const ABOUT_ME_PRODUCTS_count = "Inzer\u00e1ty (%(count)s)";
export const BEFORE_BIRTH_1 = "Je\u0161t\u011b";
export const BEFORE_BIRTH_2 = "do porodu.";
export const CHANGE = "Zm\u011b\u0148";
export const number_DAYS = ["%(number)s den", "%(number)s dny", "%(number)s dn\u016f"];
export const number_YEARS = ["%(number)s rok", "%(number)s roky", "%(number)s let"];
export const PROFILE_REGISTERED_ON_date = "Na Kon\u00edku od %(date)s";
export const PROFILE_SUMMARY__IN_num_PREGNANCY_WEEK = "v %(num)s. t\u00fddnu t\u011bhotenstv\u00ed";
export const PROFILE_SUMMARY__name_IS_in_num_pregnancy_week = "%(name)s je %(in_num_pregnancy_week)s";
export const PROFILE_VISIT_GROUP_group = "Poj\u010f do skupiny %(group)s";
export const SEND_INTERNAL_POST = "Napi\u0161 j\u00ed intern\u00ed po\u0161tu";
export const USER_LIKE = "P\u0159idej k obl\u00edben\u00fdm";
export const USER_UNLIKE = "Odeber z obl\u00edben\u00fdch";
